<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      :hideOperate="true"
      @size-change="handleSizeChange"
      @on-selection-change="selectionChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
      </div>
      <template v-slot:expand>
        <div style="margin-bottom: 20px">
          <p class="inline-p">
            当前已选择<span style="padding: 0 5px">{{ currentRow.length }}</span
            >条数据
          </p>
          <!-- <el-upload
                            class="avatar-uploader"
                            action="/file.api"
                            accept=".xls, .xlsx"
                            :show-file-list="false"
                            :data="uploadData"
                            :name="uploadName"
                            :on-success="handleAvatarSuccess">
                            <el-button style="margin-left:10px;"  type="primary">导入</el-button>
                        </el-upload> -->
          <el-button style="margin-left: 20px" type="primary" @click="toImport"
            >导入
          </el-button>
          <el-button
            style="margin-left: 20px"
            type="primary"
            @click="exportList"
            >导出
          </el-button>
          <el-button
            style="margin-left: 20px"
            type="text"
            @click="downloadTemplate"
            >下载导入模板
          </el-button>
        </div>
      </template>
    </customize-page>
    <el-dialog
      title="编辑"
      :visible="dialogVisible"
      @close="resetForm"
      width="500px"
    >
      <el-form
        :model="editRow"
        ref="form"
        label-position="right"
        label-width="150px"
        style="width: 400px; margin-left: 50px"
        :rules="rules"
      >
        <el-form-item label="货主id" prop="customerId">
          <el-select
            filterable
            v-model="editRow.customerId"
            placeholder="请选择货主"
          >
            <el-option
              v-for="item in getCustomerList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="外部商品编码" prop="outSkuId">
          <el-input v-model="editRow.outSkuId"></el-input>
        </el-form-item>
        <el-form-item label="商品条码" prop="barcodes">
          <el-input v-model="editRow.barcodes"></el-input>
        </el-form-item>
        <el-form-item label="料号" prop="itemNo">
          <el-input v-model="editRow.itemNo"></el-input>
        </el-form-item>
        <el-form-item label="金二序号" prop="itemRecordNo">
          <el-input v-model="editRow.itemRecordNo"></el-input>
        </el-form-item>
        <el-form-item label="hs编码" prop="hsCode">
          <el-input v-model="editRow.hsCode"></el-input>
        </el-form-item>
        <el-form-item label="备案名称" prop="declareName">
          <el-input v-model="editRow.declareName"></el-input>
        </el-form-item>
        <el-form-item label="原产国" prop="origin">
          <el-input v-model="editRow.origin"></el-input>
        </el-form-item>
        <el-form-item label="毛重(KG)">
          <el-input v-model="editRow.grossWeight"></el-input>
        </el-form-item>
        <el-form-item label="净重(KG)" prop="netWeight">
          <el-input v-model="editRow.netWeight"></el-input>
        </el-form-item>
        <el-form-item label="申报单位" prop="measuringUnit">
          <el-input v-model="editRow.measuringUnit"></el-input>
        </el-form-item>
        <el-form-item label="第一计量单位" prop="firstMeasuringUnit">
          <el-input v-model="editRow.firstMeasuringUnit"></el-input>
        </el-form-item>
        <el-form-item label="第一计量单位值" prop="firstValue">
          <el-input v-model="editRow.firstValue"></el-input>
        </el-form-item>
        <el-form-item label="第二计量单位">
          <el-input v-model="editRow.secondMeasuringUnit"></el-input>
        </el-form-item>
        <el-form-item label="第二计量单位值">
          <el-input v-model="editRow.secondValue"></el-input>
        </el-form-item>
        <el-form-item label="申报价格（CNY元）" prop="price">
          <el-input v-model="editRow.price"></el-input>
        </el-form-item>
        <el-form-item label="海关账册规格型号" prop="gmodel">
          <el-input v-model="editRow.gmodel"></el-input>
        </el-form-item>
        <el-form-item label="长(CM)">
          <el-input v-model="editRow.length"></el-input>
        </el-form-item>
        <el-form-item label="宽(CM)">
          <el-input v-model="editRow.width"></el-input>
        </el-form-item>
        <el-form-item label="高(CM)">
          <el-input v-model="editRow.height"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            :rows="2"
            v-model="editRow.remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <template slot="footer">
        <el-button style="margin-right: 30px" @click="resetForm"
          >取消
        </el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";
import { CONST_VD_IMGPREFIX } from "@/config/constant";

import { mapActions, mapState, mapGetters } from "vuex";

export default {
  components: {
    CustomizePage
  },
  mixins: [Page],
  mounted() {
    this.fetch();
    this.lists({
      request: {
        currentPage: 1,
        pageSize: 10
      }
    });
  },
  data() {
    return {
      uploadData: {
        _aid: 401
      },
      uploadName: "CPRODUCT_IMG.xlsx",
      loading: false,
      dataList: [],
      rules: {
        customerId: [
          { required: true, message: "请输入货主id", trigger: "change" }
        ],
        barcodes: [
          { required: true, message: "请输入商品条码", trigger: "change" }
        ],
        itemNo: [{ required: true, message: "请输入料号", trigger: "change" }],
        hsCode: [
          { required: true, message: "请输入hs编码", trigger: "change" }
        ],
        declareName: [
          { required: true, message: "请输入备案名称", trigger: "change" }
        ],
        origin: [
          { required: true, message: "请输入原产国", trigger: "change" }
        ],
        netWeight: [
          { required: true, message: "请输入商品净重", trigger: "change" }
        ],
        measuringUnit: [
          { required: true, message: "请输入申报单位", trigger: "change" }
        ],
        firstMeasuringUnit: [
          { required: true, message: "请输入第一计量单位", trigger: "change" }
        ],
        firstValue: [
          {
            required: true,
            message: "请输入第一计量单位值",
            trigger: "change"
          }
        ],
        price: [
          { required: true, message: "请输入申报单价", trigger: "change" }
        ],
        gmodel: [
          {
            required: true,
            message: "请输入海关账册规格型号",
            trigger: "change"
          }
        ]
      },
      columns: [
        {
          title: "货主id",
          width: 100,
          key: "customerId",
          align: "center"
        },
        {
          title: "账册编号",
          width: 250,
          key: "accountBookNo",
          align: "center"
        },
        {
          title: "商品条码",
          width: 250,
          key: "barcodes",
          align: "center"
        },
        {
          title: "料号",
          width: 200,
          key: "itemNo",
          align: "center"
        },
        {
          title: "金二序号",
          width: 200,
          key: "itemRecordNo",
          align: "center"
        },
        {
          title: "hs编码",
          width: 120,
          key: "hsCode",
          align: "center"
        },
        {
          title: "备案名称",
          width: 330,
          key: "declareName",
          align: "center"
        },
        {
          title: "原产国",
          width: 130,
          key: "origin",
          align: "center"
        },
        {
          title: "毛重(KG)",
          width: 130,
          key: "grossWeight",
          align: "center"
        },
        {
          title: "净重(KG)",
          width: 150,
          key: "netWeight",
          align: "center"
        },
        {
          title: "申报单位",
          width: 130,
          key: "measuringUnit",
          align: "center"
        },
        {
          title: "第一计量单位",
          width: 200,
          key: "firstMeasuringUnit",
          align: "center"
        },
        {
          title: "第一计量单位值",
          width: 180,
          key: "firstValue",
          align: "center"
        },
        {
          title: "第二计量单位",
          width: 200,
          key: "secondMeasuringUnit",
          align: "center"
        },
        {
          title: "第二计量单位值",
          width: 180,
          key: "secondValue",
          align: "center"
        },
        {
          title: "申报价格（CNY元）",
          width: 230,
          key: "price",
          align: "center"
        },
        {
          title: "海关账册规格型号",
          width: 150,
          key: "gmodel",
          align: "center"
        },
        {
          title: "仓库数量",
          width: 100,
          key: "wmsNum",
          align: "center"
        },
        {
          title: "海关库存数量",
          width: 100,
          key: "stockCustomsNum",
          align: "center"
        },
        {
          title: "冻结数量",
          width: 100,
          key: "stockFreezeNum",
          align: "center"
        },
        {
          title: "备注",
          width: 200,
          key: "remark",
          align: "center"
        },
        {
          title: "操作",
          width: 150,
          align: "center",
          fixed: "right",
          render: (h, param) => {
            let row = param.row;
            return (
              <a
                style={{ color: "#409EFF", padding: "0 10px" }}
                onClick={this.showDialog.bind(this, row)}
              >
                编辑
              </a>
            );
          }
        }
      ],
      filterObj: {
        customerId: "",
        declareName: "",
        itemNo: "",
        accountBookNo: "",
        itemRecordNo: "",
        barcodes: ""
      },
      currentRow: [],
      dialogVisible: false,
      editRow: {}
    };
  },
  computed: {
    ...mapState("record", {
      list: "list"
    }),
    ...mapGetters({
      getCustomerList: "getCustomerList"
    })
  },
  methods: {
    ...mapActions("record", [
      "lists",
      "edit",
      "import",
      "queryList",
      "preview",
      "export"
    ]),
    toImport() {
      this.$router.push({ name: "booksManageImport" });
    },
    downloadTemplate() {
      window.open(
        process.env.BASE_URL + "templates/账册库存信息新增导入.xlsx"
      );
    },
    showDialog(row) {
      if (!row) return;
      this.editRow = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
    },
    submitForm(id) {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          this.edit({
            request: { editInfo: this.editRow }
          })
            .then(res => {
              if (res.value) {
                this.$message.success("编辑成功");
                this.resetForm();
              }
              this.loading = false;
              this.fetch();
            })
            .catch(err => {
              this.fetch();
              this.loading = false;
            });
        }
      });
    },
    resetForm() {
      this.dialogVisible = false;
      setTimeout(() => {
        this.editRow = {};
      }, 0);
    },
    // 导入数据
    handleAvatarSuccess(res, file) {
      let fileUrl =
        CONST_VD_IMGPREFIX.prefixImgUrl + res.content[0][this.uploadName];
      this.loading = true;
      this.preview({ fileUrl }).then(res => {
        this.import({
          request: { importList: res.previewList }
        })
          .then(res => {
            this.loading = false;
            if (res.value) {
              this.fetch();
            } else {
              this.$message.warning("导入数据无效");
            }
          })
          .catch(err => {
            this.loading = false;
            this.$message.warning("导入数据无效");
          });
      });
    },
    // 分页加载退货订单列表
    fetch() {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      let searchCondition = {
        request: {
          queryInfo: { ...filterParams },
          pageInfo: {
            currentPage: this.pagination.currentPage,
            pageSize: this.pagination.pageSize
          }
        }
      };
      this.queryList(searchCondition)
        .then(res => {
          this.loading = false;
          this.dataList = res.items || [];
          const pageInfo = res.pageInfo || { totalCount: 0 };
          this.pagination.totalCount = pageInfo.totalCount;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "货主id",
              model: "customerId",
              type: type.SELECT,
              props: {
                data: this.getCustomerList
              }
            },
            {
              label: "备案名称",
              model: "declareName",
              type: type.INPUT
            },
            {
              label: "料号",
              model: "itemNo",
              type: type.INPUT
            },
            {
              label: "帐册编号",
              model: "accountBookNo",
              type: type.SELECT,
              props: {
                data: this.calculateArr(this.list)
              }
            },
            {
              label: "金二序号",
              model: "itemRecordNo",
              type: type.INPUT
            },
            {
              label: "商品条码",
              model: "barcodes",
              type: type.INPUT
            }
          ]
        }
      ];
    },
    // 将列表转为可供select组件使用的数组
    calculateArr(arr) {
      if (!arr || !arr.length) return;
      let theArr = [];
      arr.map(v => {
        theArr.push({
          value: v.id,
          label: v.value
        });
      });
      return theArr;
    },
    selectionChange(rows) {
      this.currentRow = rows;
    },
    // 导出列表
    exportList(data) {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      this.export({
        request: {
          queryInfo: { ...filterParams }
        }
      }).then(res => {
        this.loading = false;
        if (res.value) {
          this.$alert("提交成功", "提示", {
            confirmButtonText: "确定",
            callback: action => {
              this.$router.push({ name: "download" });
            }
          });
        } else {
          this.$message.error("提交失败");
        }
      });
    }
  }
};
</script>

<style>
.inline-p {
  display: inline-block;
}

.inline-p span {
  color: #3399ff;
}

.filter_con.filterUp .filter-form {
  height: auto;
  overflow: visible;
}
</style>
